import { Search as SearchIcon } from '@air/icons';
import { Box, BoxProps, Input as DeprecatedInput } from '@air/zephyr';
import { Formik } from 'formik';
import { debounce } from 'lodash';
import { ChangeEvent } from 'react';

import { Form } from '~/old-marketing/components/Form';

export interface AgencyListSearchProps extends Pick<BoxProps, 'tx'> {
  onChange: (value: string) => void;
  value: string;
}

export const AgencyListSearch = ({ onChange, tx, value }: AgencyListSearchProps) => {
  const onSearchChange = debounce(onChange, 500);

  return (
    <Formik initialValues={{ search: value }} onSubmit={({ search }) => onSearchChange(search)}>
      {({ handleChange }) => (
        <Box as={Form} tx={{ display: 'flex', width: '100%', ...tx }}>
          <DeprecatedInput
            adornment={{
              location: 'left',
              component: <SearchIcon />,
            }}
            isLabelHidden
            label="Search"
            name="search"
            onChange={(event: ChangeEvent<any>) => {
              handleChange(event);
              onSearchChange(event.target.value);
            }}
            placeholder="Search in Air HQ"
            required={false}
            tx={{ flexGrow: 1, mr: 8, InnerInput: { backgroundColor: 'pigeon050', border: 'none' } }}
            type="text"
            variant="field-input-chonky"
          />
        </Box>
      )}
    </Formik>
  );
};
